import { useNavigate } from "react-router-dom";

function ListaChats({ chats = [], estadoChats = "activos", cambiarEstadoChats, paginacion, setPagina, onReactivar }) {
    const navigate = useNavigate();

    function verConversacion(chat) {
        if (!chat?.idConversacion) return;

        navigate("/admin/conversacion", {
            state: {
                params: {
                    idMensaje: chat.idConversacion,
                }
            }
        });
    }

    function formatearFecha(fecha) {
        if (!fecha) return "Sin fecha";

        try {
            return new Date(fecha).toLocaleString("es-CO", {
                day: "2-digit",
                month: "short",
                hour: "2-digit",
                minute: "2-digit",
            });
        } catch (err) {
            return "Sin fecha";
        }
    }

    function etiquetaEstado(estado) {
        const estados = {
            esperando_asesor: "Esperando asesor",
            abierta: "Abierta",
            pendiente: "Pendiente",
            resuelta: "Resuelta",
        };

        return estados[estado] || estado || "Sin estado";
    } 

    function claseEstado(estado) {
        if (estado === "esperando_asesor") return "bg-warning-subtle text-warning-emphasis border border-warning-subtle";
        if (estado === "abierta") return "bg-success-subtle text-success-emphasis border border-success-subtle";
        if (estado === "pendiente") return "bg-info-subtle text-info-emphasis border border-info-subtle";
        if (estado === "resuelta") return "bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle";
        return "bg-light text-muted border";
    }

    return (
        <div className="w-100 mt-3">
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3 mb-3">
                <div>
                    <h2 className="h5 mb-1 text-dark">Chats de WhatsApp</h2>
                    <p className="text-muted mb-0 small">
                        {estadoChats === "finalizados" ? "Conversaciones resueltas o finalizadas por soporte." : "Conversaciones que ya necesitan atención de soporte."}
                    </p>
                </div>

                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className="btn-group btn-group-sm" role="group" aria-label="Filtro de chats">
                        <button 
                            type="button" 
                            className={`btn rounded-start-pill px-3 ${estadoChats === "activos" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => cambiarEstadoChats?.("activos")}
                        >
                            Activos
                        </button>
                        <button 
                            type="button" 
                            className={`btn rounded-end-pill px-3 ${estadoChats === "finalizados" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => cambiarEstadoChats?.("finalizados")}
                        >
                            Finalizados
                        </button>
                    </div>

                    <span className="badge rounded-pill bg-primary-subtle text-primary-emphasis border border-primary-subtle">
                        {paginacion?.total ?? chats.length} chat{(paginacion?.total ?? chats.length) === 1 ? "" : "s"}
                    </span>
                </div>
            </div>

            {!chats.length ? (
                <div className="border rounded-4 p-4 bg-light text-center">
                    <i className="bi bi-headset fs-2 text-muted"></i>
                    <h3 className="h6 mt-2 mb-1 text-dark">No hay chats pendientes</h3>
                    <p className="text-muted small mb-0">Cuando un usuario pida hablar con un asesor, aparecerá aquí.</p>
                </div>
            ) : (
                <div className="d-flex flex-column gap-2">
                    {chats.map((chat) => {
                        const nombre = chat?.nombreWhatsapp && chat.nombreWhatsapp !== "NA" ? chat.nombreWhatsapp : "Usuario de WhatsApp";
                        const telefono = chat?.telefonoWhatsapp || chat?.waId || "Sin teléfono";
                        const ultimoMensaje = chat?.ultimoMensaje || "Sin último mensaje";
                        const sinLeer = Number(chat?.mensajesSinLeerAsesor || 0);

                        return (
                            <div key={chat?._id || chat?.idConversacion} className="card border-0 shadow-sm rounded-4">
                                <div className="card-body py-3">
                                    <div className="d-flex flex-column flex-lg-row align-items-lg-center gap-3">
                                        <div className="d-flex align-items-center gap-3 flex-grow-1 min-width-0">
                                            <div className="rounded-circle bg-primary-subtle text-primary d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: 46, height: 46 }}>
                                                <i className="bi bi-whatsapp fs-5"></i>
                                            </div>

                                            <div className="min-width-0">
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    <h3 className="h6 mb-0 text-dark text-truncate">{nombre}</h3>
                                                    {sinLeer > 0 ? (
                                                        <span className="badge rounded-pill bg-danger">{sinLeer}</span>
                                                    ) : null}
                                                </div>

                                                <div className="text-muted small mt-1">
                                                    <i className="bi bi-phone me-1"></i>{telefono}
                                                    <span className="mx-2">•</span>
                                                    <span>{chat?.tipoUsuario || "desconocido"}</span>
                                                </div>

                                                <p className="mb-0 mt-1 text-secondary small text-truncate" style={{ maxWidth: 560 }}>
                                                    {ultimoMensaje}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between justify-content-lg-end gap-3 flex-wrap flex-lg-nowrap">
                                            <div className="text-lg-end">
                                                <span className={`badge rounded-pill px-3 py-2 ${claseEstado(chat?.estado)}`}>
                                                    {etiquetaEstado(chat?.estado)}
                                                </span>
                                                <div className="text-muted small mt-2">
                                                    <i className="bi bi-clock me-1"></i>{formatearFecha(chat?.fechaUltimoMensaje || chat?.updatedAt)}
                                                </div>
                                            </div>

                                            {chat?.estado === "resuelta" && (
                                                <button
                                                    className="btn btn-sm btn-outline-success rounded-pill px-3"
                                                    type="button"
                                                    onClick={() => onReactivar?.(chat)}
                                                >
                                                    <i className="bi bi-arrow-counterclockwise me-1"></i>
                                                    Reactivar
                                                </button>
                                            )}
                                            <button
                                                className="btn btn-sm btn-primary rounded-pill px-3"
                                                type="button"
                                                onClick={() => verConversacion(chat)}
                                            >
                                                Ver conversación
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            <div className="d-flex justify-content-between align-items-center mt-3 pt-2">
                <button 
                    type="button" 
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                    disabled={(paginacion?.pagina || 1) <= 1}
                    onClick={() => setPagina?.((prev) => Math.max(prev - 1, 1))}
                >
                    <i className="bi bi-chevron-left me-1"></i>
                    Anterior
                </button>

                <span className="text-muted small">
                    Página {paginacion?.pagina || 1} de {paginacion?.totalPaginas || 1}
                </span>

                <button 
                    type="button" 
                    className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                    disabled={!paginacion?.hayMas}
                    onClick={() => setPagina?.((prev) => prev + 1)}
                >
                    Siguiente
                    <i className="bi bi-chevron-right ms-1"></i>
                </button>
            </div>
        </div>
    );
}

export default ListaChats;